import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';

function initializeSentry(tracesSampleRate = 0.1): void {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: `${process.env.REACT_APP_NAME}-${process.env.REACT_APP_VERSION}`,
    integrations: [new BrowserTracing()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: tracesSampleRate,
  });
}

export { initializeSentry };
